import { keyframes } from "@emotion/react";

const changeColorAnimation = keyframes`
    0% {
        background-color: rgba(255,244,229,0);
    }
    50% {
        background-color: rgba(255,244,229,0.5);
    }
    100% {
        background-color: rgba(255,244,229,1);
    }
`;

export default changeColorAnimation